import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';
import { environment } from '../../environments/environment';
import { OrganizzazioneStore } from '../modules/organizzazione/organizzazione.store';

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    InputTextModule,
    StyleClassModule,
    ButtonModule,
  ],
  template: `
    <header>
      <nav class="relative w-full flex items-center px-8 lg:px-20 gap-2 py-6 lg:py-2">
        <img [src]="store.logoSrc()" class="max-h-25" alt="Image" />
        <a
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-fadein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
          resizeSelector=".resize-container-6"
          [hideOnResize]="true"
          class="relative z-20 cursor-pointer block lg:hidden text-surface-700 dark:text-surface-100 mr-0 ml-auto"
        >
          <i class="pi pi-bars text-2xl!"></i>
        </a>
        <div
          class="border-b border-surface lg:border-0 animate-fadein absolute lg:static bg-surface-50 dark:bg-surface-900 lg:bg-transparent lg:dark:bg-transparent w-full top-full left-0 right-0 shadow-md lg:shadow-none z-20 lg:z-auto pt-0 lg:py-0 hidden lg:flex flex-1 items-center"
        >
          <ul
            class="mt-4 lg:mt-0 lg:border-0 select-none relative flex-1 flex lg:flex-row flex-col lg:mb-0 mb-4 lg:items-center gap-2 lg:gap-6 p-4"
          ></ul>
          <!-- LG Mega menu positioned relative to navbar (full width) -->

          <div
            class="flex items-center justify-between lg:justify-center gap-6 px-4 lg:px-0 py-4 lg:py-0 border-t border-surface-200 dark:border-surface-700 lg:border-0"
          >
            <a pButton [text]="true" [href]="loginUrl" target="_blank">
              <span pButtonLabel>Login</span>
            </a>
          </div>
        </div>
      </nav>
    </header>
  `,
})
export class AppHeader {
  store = inject(OrganizzazioneStore);
  loginUrl = environment.browserUrl + '/login';
  constructor() {}
}
